import { render } from "./RobotTxt.vue?vue&type=template&id=cc3c4bc6"
import script from "../js/robot-txt.js?vue&type=script&lang=js"
export * from "../js/robot-txt.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__